import { buildPositionStyle } from './buildPositionStyle';

/**
 * 构造fixed定位对象
 * @param {*} position
 * @returns
 */
export function positionToStyleForFixed(position) {
    const style = buildPositionStyle(position);
    style.position = 'fixed';
    return style;
}
